import { Suspense, useEffect, useState, lazy } from "react";

// Libraries
import { Routes, Route, useLocation } from "react-router-dom";
import retina from "retinajs";
import { AnimatePresence } from "framer-motion";

// Context
import GlobalContext from "./Context/Context";

// Components
import ScrollToTopButton from "./Components/ScrollToTop";
import useMetaPageView from "./useMetaPageView";
import BlogPostLayout01 from "./Pages/Blogs/LayoutPage/BlogPostLayout01";
import BlogPostLayout02 from "./Pages/Blogs/LayoutPage/BlogPostLayout02";

// Home
const SignUp = lazy(() => import("./Pages/Games/SignUp5"));
const ThankYou = lazy(() => import("./Pages/Games/ThankYouReserve"));
const ReservationSuccess = lazy(() => import("./Pages/Games/ReservationSuccess"));
const PrivacyPolicy = lazy(() => import("./Pages/Games/PrivacyPolicy"));
const RefundPolicy = lazy(() => import("./Pages/Games/RefundPolicy"));
const Unsubscribe = lazy(() => import("./Pages/Games/Unsubscribe"));
const EventSignUp = lazy(() => import("./Pages/Games/EventSignUp"));

const BlogModernPage = lazy(() => import("./Pages/Blogs/BlogModern"));
const BlogOverlayImgPage = lazy(() => import("./Pages/Blogs/BlogOverlayImg"));

function App() {
  const [headerHeight, setHeaderHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [customModal, setCustomModal] = useState({
    el: null,
    isOpen: false,
  });
  const location = useLocation();

  // RetinaJS
  useEffect(() => {
    window.addEventListener("load", retina(document.querySelectorAll("img")));
  }, []);

  useEffect(() => {
    setTimeout(() => {
      import("./Functions/Utilities").then((module) => {
        module.SetHeaderMenuPos();
        module.setDocumentFullHeight();
      });
    }, 1000);
  }, [location]);

  useEffect(() => {
    if (isModalOpen === true) {
      document.querySelector("body").classList.add("overflow-hidden");
    } else {
      document.querySelector("body").classList.remove("overflow-hidden");
    }
  }, [isModalOpen]);

  // Get the current location and set the window to top
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    setFooterHeight(0);
    setCustomModal({
      ...customModal,
      el: null,
      isOpen: false,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useMetaPageView();
  return (
    <GlobalContext.Provider
      value={{
        headerHeight,
        setHeaderHeight,
        footerHeight,
        setFooterHeight,
        isModalOpen,
        setIsModalOpen,
        customModal,
        setCustomModal,
      }}
    >
      <div className="App" style={{ "--header-height": `${headerHeight}px` }}>
        {
          <main style={{ marginTop: headerHeight, marginBottom: footerHeight }}>
            <ScrollToTopButton />
            <AnimatePresence exitBeforeEnter>
              <Suspense fallback={<></>}>
                <Routes>
                  {/* <Route path="/" element={<HomePage />} /> */}
                  {/* <Route path="/games" element={<GamePage />} /> */}
                  <Route path="/" element={<SignUp />} />
                  {/* <Route path="/signup" element={<SignUp />} /> */}
                  <Route path="/thankyou" element={<ThankYou />} />
                  <Route path="/reserve" element={<ThankYou />} />
                  <Route path="/reservation-success" element={<ReservationSuccess />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/refund-policy" element={<RefundPolicy />} />
                  <Route path="/unsubscribe" element={<Unsubscribe />} />
                  <Route path="/signup" element={<EventSignUp />} />
                  
                </Routes>
              </Suspense>
            </AnimatePresence>
          </main>
        }
      </div>
    </GlobalContext.Provider>
  );
}

export default App;
